<template>
  <div>
    <City
      v-model="accountCity"
      :label="$$t('City', 'label')"
      :country="currentCountryData"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { translate } from '@/mixins/translate';
import City from '@/components/molecules/form/autoComplete/City';

export default {
  name: 'AccountEditCity',
  components: {
    City,
  },
  mixins: [translate('_web_account-edit_city')],
  computed: {
    ...mapGetters(['accountEditData']),
    currentCountryData() {
      const { country, country_id } = this.accountEditData;
      return country
        ? {
            id: country_id,
            name: country,
          }
        : null;
    },
    accountCity: {
      get() {
        return this.accountEditData.city;
      },
      set(city) {
        this.updateEditData({
          city: city ? city.value : '',
          city_id: city ? city.id : '',
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateEditData']),
  },
};
</script>
